module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQMAAABKLAcXAAAABlBMVEUAAADwUDMVyPZdAAAAAXRSTlMAQObYZgAAAUhJREFUOMutlMFtxCAQRY2I4iMluBTSGS7NpbgEjhwQE48/A38Vr3JZTjwJ+81ngOWDw2UmX5nWxhSEaZOdKMpBlOQkEsmkEymkE6kv1F5WsvCinQ0k/IlCwnMjocuBhL6sJFwrC0Nj4SbLOoVRdjeF6ZpNocqG0OksmdCDatfpN8mEASSm05UmjKAuTEojoWgcS+hEA1hCLxrAEq5KX5YwKH1bwk1ptS2NN+1dmG46ulBuOpHQgbSaculAWk29dKD6hxpR+I/8/G5Swz/dpDIqk6uWPKqWA1VHkCDRBuppwyDsEgi75I2qkjMqtvNNF2TrStEF5+wYdNZN6FTYu/l0CjyoPp2eBZQBOqNTpx2ADsLqoOvCAB2ESGdCpDMh0pkQ6YYQOhNCZ0LoTAjdELbnGz5v/0z49tWI0PFrQ8L3r5SHzgZ0Hxq/pE7N4IdS+sAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/git.png
// module id = veVj
// module chunks = 1